import React from "react";
import LocalStorageService from "../../core/services/local-storage.service";
import { getIntelUrl } from "../../utils/intelUrl";
import ReactToPrint from "react-to-print";
import { AnalyticsDownloadContent } from "./analytics-download-content";
import { Helmet } from "react-helmet";

const localStorageService = LocalStorageService.getService();
export default class AnalyticsDownloadPDF extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
    const analyticsData = localStorageService.getAnalyticsDownloadData();
    if (analyticsData !== undefined && analyticsData !== null && analyticsData !== "") {
      this.state = {
        completeAnalyticsData: analyticsData,
      };
    } else {
      window.location.href = getIntelUrl() + "404";
    }
  }
  componentDidMount() {
    setTimeout(() => {
      document.getElementById("print-button").click();
    }, 100);
  }
  onPrintErrorcustomMethod() {
    localStorageService.clearAnalyticsDownloadData();
    window.close();
  }
  onAfterPrintCustomMeothod() {
    localStorageService.clearAnalyticsDownloadData();
    window.close();
  }
  render() {
    return (
      <>
        <ReactToPrint trigger={() => <button id="print-button" style={{ visibility: "hidden" }}></button>} content={() => this.componentRef} onPrintError={() => this.onPrintErrorcustomMethod()} onAfterPrint={() => this.onAfterPrintCustomMeothod()} copyStyles={true} />
        {!!this && !!this.state && !!this.state.completeAnalyticsData ? (
          <>
            <Helmet>
              <meta charSet="utf-8" />
            </Helmet>
            <AnalyticsDownloadContent ref={(el) => (this.componentRef = el)} analyticsData={this.state.completeAnalyticsData}></AnalyticsDownloadContent>
          </>
        ) : (
          <></>
        )}
      </>
    );
  }
}
